import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const ApiPermissionsModalForm = ({
    setOpenAPIpermissionsModal,
    getUser,
    user,
}) => {
  const [loading, setLoading] = useState(false);
  const [permissions, setPermissions] = useState([
    { id: 1, name: "Partner API V1", value: "partner_api_v1", checked: false },
    { id: 2, name: "Partner API V2", value: "partner_api_v2", checked: false },
    { id: 3, name: "Bookings API", value: "bookings", checked: false },
  ]);

  const cancel = () => {
      setOpenAPIpermissionsModal(false);
  };

  const handleSetPermissions = () => {
    const selectedPermissions = permissions.filter((p) => p.checked)?.map((p) => p.value);

    axios.patch(`${process.env.REACT_APP_API_V3_URL}/partner/${user.partner_id}/permissions`, { 
      permissions: selectedPermissions 
    })
      .then(() => {
        toast.success("API permissions have been modified for this user successfully");
        getUser();
        cancel();
      })
      .catch((err) => {
        if (err && err.response && err.response?.data && err.response?.data?.message) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Technical Error, Please Try Again");
        }
      }); 
  }

  return (
    <>
        <div
          className="d-flex flex-column scroll-y me-n7 pe-7"
          id="kt_modal_add_user_scroll"
          data-kt-scroll="true"
          data-kt-scroll-activate="{default: false, lg: true}"
          data-kt-scroll-max-height="auto"
          data-kt-scroll-dependencies="#kt_modal_add_user_header"
          data-kt-scroll-wrappers="#kt_modal_add_user_scroll"
          data-kt-scroll-offset="300px"
        >
            <h4 className="mb-7">Select Partners API permissions for the User:</h4>
            <div className="mt-2 d-flex flex-column gap-3">
            {
              permissions.map((el, index) => (
                <div className="form-check form-check-custom form-check-solid" key={index}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={el.value}
                    id="flexCheckChecked"
                    checked={el.checked}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setPermissions((prev) =>
                      prev.map((el) => {
                        if (el.value === e.target.value) {
                          return { ...el, checked };
                        }
                        return el;
                      })
                    );
                  }}
                  />
                  <label
                    className="form-check-label"
                    style={{ fontWeight: "700", color: "#3f4254" }}
                  >
                    {el.name}
                  </label>
                </div>
              ))
            }
          </div>
        </div>
        <div className="text-center pt-15">
          <button
            type="reset"
            onClick={() => cancel()}
            className="btn btn-light mx-3"
            data-kt-users-modal-action="cancel"
          >
            Discard
          </button>

          <button
            type="submit"
            className="btn"
            data-kt-users-modal-action="submit"
            disabled={!permissions.some((el) => el.checked) || loading}
            style={{ background: "#ffa459", color: "#fff" }}
            onClick={handleSetPermissions}
          >
            <span className="indicator-label">Confirm Permissions</span>
          </button>
        </div>
    </>
  );
};

export { ApiPermissionsModalForm };
